module.exports = __webpack_public_path__ + "img/heading_no.91549b0e.svg";